import { invoicee, Site } from 'interfaces/site';
import { http, HttpResponse } from 'msw';
import { buildSite } from '../../factories';
import { canonicalSites } from '../../factories/seeds/entities';

const DEFAULT_SITE_TIMEZONE = 'America/Winnipeg';

const toMockSite = (site: (typeof canonicalSites)[number]): Site => {
  return buildSite<Site>({
    ...site,
    organization: undefined,
  }) as Site;
};

export const mockSites: Site[] = canonicalSites.map(toMockSite);

export const testSite: Site = buildSite<Site>({
  id: '1',
  name: 'New Site',
  address: 'test',
  city: 'test',
  province: 'test',
  email: 'test@example.com',
  phone: '+12045555555',
  postalCode: 'R1R1R1',
  invoicee: invoicee.site,
  invoiceRate: 0,
  overhead: 0,
  organization: null,
  fax: 'test',
  region: 'test',
  status: 'Active',
  description: 'test',
  proFees: true,
  techFees: true,
  organizationID: mockSites[mockSites.length - 1]?.organizationID ?? '',
  siteNumber: 'test',
  hospitalCode: 'test',
  apiID: '',
  apiSecret: '',
  apiKey: '',
  autoRemit: false,
  cheque: false,
  creditCard: false,
  etransfer: false,
  requiresTariffIcd9: true,
  creditCardPhoneNumber: null,
  etransferEmail: null,
  etransferPasswordRequirement: null,
  timezone: DEFAULT_SITE_TIMEZONE,
  allowUploads: true,
}) as Site;

//@ts-expect-error - This site is intentionally invalid for testing purposes
export const invalidSite: Site = {
  id: '1',
  name: '',
  address: '',
  city: '',
  province: '',
  invoicee: invoicee.site,
  invoiceRate: 0,
  overhead: 0,
  organization: null,
  fax: '',
  region: '',
  status: 'Active',
  description: '',
  proFees: true,
  techFees: true,
  organizationID: mockSites[mockSites.length - 1]?.organizationID ?? '',
  siteNumber: 'test',
  hospitalCode: 'test',
  apiID: '',
  apiSecret: '',
  apiKey: '',
  autoRemit: false,
  cheque: false,
  creditCard: false,
  etransfer: false,
  requiresTariffIcd9: true,
  creditCardPhoneNumber: null,
  etransferEmail: null,
  etransferPasswordRequirement: null,
  timezone: DEFAULT_SITE_TIMEZONE,
  allowUploads: true,
};

export const mockSiteHandlers = [
  // Mock for listSites
  http.get('*/resource/site/all', () => {
    return HttpResponse.json(mockSites);
  }),

  // Mock for getSite
  http.get('*/resource/site', () => {
    return HttpResponse.json(mockSites[0]);
  }),
  // Mock for listSitesByOrganization
  http.get(`*/resource/site/organization`, ({ request }) => {
    const url = new URL(request.url).searchParams;
    const orgID = url.get('organizationID');
    const sites = mockSites.filter(
      (site) => site.organizationID === orgID.toString()
    );
    return HttpResponse.json(sites);
  }),
  http.get('*/resource/site/user', () => {
    return HttpResponse.json(mockSites);
  }),
  http.get('*/resource/site/user/*', () => {
    return HttpResponse.json(mockSites);
  }),
  http.get('*/resource/site/metrics', () => {
    return HttpResponse.json({
      agingClaims: 0,
      agingClaimProviders: [],
      errorClaims: 0,
      errorClaimProviders: [],
      latestRemittance: null,
      latestSubmission: null,
    });
  }),
  // Mock for createSite
  http.post('*/resource/site', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.put('*/resource/site', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
];
